import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { MustMatch } from '../../shared/validators/must-match.validator';
import { AuthService } from '../auth.service';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/index';
import { UIService } from '../../shared/ui.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  resetPasswordFormGroup: FormGroup;
  token = null;
  hide = true;
  hide2 = true;
  isLoading = false;

  private loadingSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private uiService: UIService
  ) { }

  ngOnInit() {
    this.resetPasswordFormGroup = this.formBuilder.group({
      'password' : [null, Validators.required],
      'passwordConfirm' : [null, Validators.required]
    }, {
            validator: MustMatch('password', 'passwordConfirm')
          });

    this.route.paramMap.subscribe(params => {
      const token = params.get('token');
      console.log(token);
      this.token = token;
    });

    this.loadingSubscription = this.uiService.loadingStateChanged.subscribe(isLoading => {
      this.isLoading = isLoading;
      //this.showWrongEmailPasswordMessage = true;
      //this._ref.markForCheck();
    });
  }

  switchLanguage(language: string) {
    this.translate.use(language);
  }

  getLanguage() {
    return this.translate.currentLang;
  }

  onSubmit() {
    const authData = {
      token: this.token,
      password: this.resetPasswordFormGroup.value.password
    };
    this.authService.resetPassword(authData);
  }

  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
  }

}
